import { Header } from "@/components/header/Header.js";
import { Main } from "@/components/main/Main.js";

import { createElement } from "@/utils/create-elem.js";

export const App = (parent) => {
  const container = createElement({
    tag: "div",
    classes: ["container"],
    parent: parent,
  });

  Header(container);
  Main(container);
};
